import breakpointsFunc from '../breakpointsFunc';
const MuiGrid = {
  styleOverrides: {
    root: {
      [breakpointsFunc.breakpoints.down('sm')]: {
        flexDirection: 'column'
      }
    }
  }
};
export default MuiGrid;